import {util} from '@utils'
import Mine from './mine'
import enterManageRouting from './enterManage/enterManage-routing'
import serveManageRouting from './serveManage/serveManage-routing'
import accountBindCodeRouting from './accountBindCode/accountBindCode-routing'
import workbenchRouting from './workbench/workbench-routing'

export default [{
    path: '/mine',
    name: 'mine',
    component: Mine,
    beforeEnter: (to, from, next) => {
        const toName = to && to.name ? to.name :'';
       const ensureLogin =  util.ensureLogin(toName)
       if(ensureLogin) {
        next();
       }    
    },
    children:[...enterManageRouting,...accountBindCodeRouting,...workbenchRouting,...serveManageRouting]
}]
